import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Tick = createIcon({
  displayName: "Tick",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.2235 6.20672C20.4242 6.39646 20.433 6.71292 20.2433 6.91356L9.97328 17.7736C9.8805 17.8717 9.75199 17.9281 9.61697 17.93C9.48196 17.9318 9.35192 17.879 9.25644 17.7836L3.76644 12.2936C3.57118 12.0983 3.57118 11.7817 3.76644 11.5865C3.9617 11.3912 4.27829 11.3912 4.47355 11.5865L9.59999 16.7129L19.5167 6.22646C19.7064 6.02582 20.0229 6.01699 20.2235 6.20672Z"
    />
  )
});
